/**
 * Handle Accordion trigger click.
 *
 * @returns  {Void}
 */
function handleAccordionTriggerClick() {
	const currentClickedSection = this.closest('.accordion__section');
	const currentActiveSection = this.closest('.js-accordion').querySelector('.is-active');

	if (currentActiveSection && currentActiveSection !== currentClickedSection) {
		currentActiveSection.classList.remove('is-active');
	}

	currentClickedSection.classList.toggle('is-active');
}

/**
 * Events
 */
document.querySelectorAll('.js-accordion .accordion__head').forEach((accordionTrigger) => {
	accordionTrigger.addEventListener('click', handleAccordionTriggerClick);
});
